import { useInfiniteQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

const getNextPageParam = ({
	next
}: CMSPaginatedData<{ name: string; uuid: string }>) => {
	return next;
};

export const fetchHashtag = async (name?: string, nextPageUrl?: string) => {
	const url = nextPageUrl || `/hashtag/?search=${name}&page=1`;

	const { data } =
		await cmsClient.get<CMSPaginatedData<{ name: string; uuid: string }>>(url);

	return data;
};

const useHashtags = (name?: string, options: Options = { enabled: true }) => {
	const query = useInfiniteQuery(
		["hashtags", name],
		({ pageParam }) => fetchHashtag(name, pageParam),
		{
			getNextPageParam,
			enabled: options.enabled
		}
	);

	return query;
};

export default useHashtags;
